import React from 'react';
import { Glyphicon, OverlayTrigger, Popover } from 'react-bootstrap'

class Checks extends React.Component {
    render() {
        if (this.props.processing)
            return (<span>Processing...</span>);

        if (this.props.error !== undefined)
            return (<small style={{ color: "red" }}>Error during checks.</small>);

        if (this.props.checks === undefined || this.props.checks === null || this.props.checks.length === 0)
            return (<small>Nothing to check.</small>);

        const CheckList = this.props.checks.map((c) => {
            let errorPopover = null;

            if (c.response.error != null)
                errorPopover = (
                    <Popover id="popover-trigger-hover-focus" title="Error Description">
                        <small>{c.response.error.errorMessage}</small><br />
                        <small>{c.response.error.errorDetail}</small>
                    </Popover>
                );

            // Render checks
            return (
                <div key={c.name}>
                    {c.response.status &&
                        <Glyphicon glyph="check" style={{ color: "green" }} />}
                    {!c.response.status &&
                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={errorPopover}>
                            <Glyphicon glyph="record" style={{ color: "red" }} />
                        </OverlayTrigger>
                    }
                    &nbsp;
                    <small>{c.name}</small>
                </div>
            )
        })

        return (
            <div>
                {CheckList}
            </div>)
    }
}

export default Checks;


// WEBPACK FOOTER //
// ./src/areas/admin/console/services/Checks.js